import script from "./IniFileSpeedAlertSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./IniFileSpeedAlertSetting.vue?vue&type=script&setup=true&lang=ts"

import "./IniFileSpeedAlertSetting.vue?vue&type=style&index=0&id=dfb537bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfb537bc"]])

export default __exports__